import React, { useEffect, useState } from "react";
import "./Khadyaadvreportprint.css";
import axios from "axios";

import { Document, Page, Text, View, StyleSheet, PDFViewer, Image } from "@react-pdf/renderer";
import { Font } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

import NotoSansKannada from "../../Fonts/NotoSansKannada.ttf";
import LatoItalicFont from "../../Fonts/Baloo2-VariableFont_wght.ttf";
import Logo from "../../imgs/dairylogo.png";

// ✅ Register fonts
Font.register({ family: "Lato-Italic", src: LatoItalicFont });
Font.register({ family: "Kannada", src: NotoSansKannada });

const Khadyaadvreportprint = () => {
  const { t, i18n } = useTranslation();

  const lang = i18n?.language || localStorage.getItem("i18nextLng") || "mr";
  const fontBase = (lang || "").toLowerCase().startsWith("kn") ? "Kannada" : "Lato-Italic";

  // ✅ helper to force font without changing your StyleSheet
  const F = (styleObj) => [styleObj, { fontFamily: fontBase }];

  const [customerData, setCustomerData] = useState([]);
  const [PreviousAmt, setPreviousAmt] = useState(0);

  let totals = {};

  // ---------------- helpers ----------------
  const chunk = (arr, size) => {
    if (!Array.isArray(arr) || size <= 0) return [];
    const out = [];
    for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
    return out;
  };

  const num = (v) => {
    const n = Number(String(v ?? "").replace(/[^\d.-]/g, ""));
    return Number.isFinite(n) ? n : 0;
  };

  function formatDate(inputDate) {
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return new Date(inputDate).toLocaleDateString("en-US", options);
  }

  // ---------------- encoder (keep same) ----------------
  var jsEncode = {
    encode: function (s, k) {
      var enc = "";
      var str = s.toString();
      for (var i = 0; i < str.length; i++) {
        var a = str.charCodeAt(i);
        var b = a ^ k;
        enc = enc + String.fromCharCode(b);
      }
      return enc;
    },
  };

  // ---------------- API load ----------------
  useEffect(() => {
    let phplanding = "";
    const khrtype = localStorage.getItem("khrtype");

    if (khrtype === "khpur") phplanding = "getkhpurreport.php";
    else if (khrtype === "khsale") phplanding = "getkhsalereport.php";
    else if (khrtype === "adv") phplanding = "getadvreport.php";
    else if (khrtype === "udhari") phplanding = "getudhari4.php";
    else if (khrtype === "thakbaki") phplanding = "getthakbaki2.php";
    else if (khrtype === "stock") phplanding = "getkhstock.php";
    else if (khrtype === "datestock") phplanding = "getkhstockbydate.php";
    else if (khrtype === "dreport") phplanding = "getkhpartystatement2.php";

    var mainuser2 = jsEncode.encode("mamapr", 125);

    let rawData = {
      date1: localStorage.getItem("date1print"),
      date2: localStorage.getItem("date2print"),
      kno: localStorage.getItem("kno"),
      partyname: localStorage.getItem("partyname"),
      khname: localStorage.getItem("khname"),
      mainuser: localStorage.getItem("contact"),
      billtype: localStorage.getItem("bill10type"),
      mainuser2: mainuser2,
    };

    rawData = JSON.stringify(rawData);

    let formData = new FormData();
    formData.append("data", rawData);

    axios
      .post(`https://excellentdairy.com/dairy/php/cust/${phplanding}`, formData, {
        "Content-Type": "multipart/form-data",
      })
      .then(function sample(response) {
        const arr = Array.isArray(response.data) ? response.data : [];
        setCustomerData(arr);

        // If your API gives opening/previous balance for dealer report somewhere,
        // set it here. Keeping safe default 0.
        // setPreviousAmt(...);
      })
      .catch((err) => {
        console.log(err);
        setCustomerData([]);
      });
  }, []);

  // ---------------- totals ----------------
  const khrtype = localStorage.getItem("khrtype");
  const bill10type = localStorage.getItem("bill10type");

  if ((khrtype === "khpur" || khrtype === "khsale") && customerData.length > 0) {
    totals = {
      tquin: customerData.reduce((total, rowData) => total + num(rowData.quin), 0),
      tamt: customerData.reduce((total, rowData) => total + num(rowData.amt), 0),
    };
  } else if (khrtype === "adv" && customerData.length > 0) {
    totals = {
      tamt: customerData.reduce((total, rowData) => total + num(rowData.amt), 0),
    };
  } else if (khrtype === "udhari" && bill10type === "1" && customerData.length > 0) {
    totals = {
      tamtadv: customerData.reduce((total, rowData) => total + num(rowData.newadv), 0),
      tamtkhadya: customerData.reduce((total, rowData) => total + num(rowData.newkhadya), 0),
      tamtratib: customerData.reduce((total, rowData) => total + num(rowData.newratib), 0),
      tamtkarj: customerData.reduce((total, rowData) => total + num(rowData.newkarj), 0),
      tamtsangh: customerData.reduce((total, rowData) => total + num(rowData.newsangh), 0),
      tamtretan: customerData.reduce((total, rowData) => total + num(rowData.newretan), 0),
      tamt: customerData.reduce(
        (total, rowData) =>
          total +
          (num(rowData.newadv) +
            num(rowData.newkhadya) +
            num(rowData.newratib) +
            (localStorage.getItem("karj") === "On" ? num(rowData.newkarj) : 0) +
            (localStorage.getItem("sanghk") === "On" ? num(rowData.newsangh) : 0) +
            (localStorage.getItem("retan") === "On" ? num(rowData.newretan) : 0)),
        0
      ),
    };
  } else if (khrtype === "thakbaki" && customerData.length > 0) {
    totals = {
      tamtadv: customerData.reduce((total, rowData) => total + num(rowData.newadv), 0),
      tamtkhadya: customerData.reduce((total, rowData) => total + num(rowData.newkhadya), 0),
      tamtratib: customerData.reduce((total, rowData) => total + num(rowData.newratib), 0),
      tamtkarj: customerData.reduce((total, rowData) => total + num(rowData.newkarj), 0),
      tamtsangh: customerData.reduce((total, rowData) => total + num(rowData.newsangh), 0),
      tamtretan: customerData.reduce((total, rowData) => total + num(rowData.newretan), 0),
      tamt: customerData.reduce(
        (total, rowData) =>
          total +
          (num(rowData.newadv) +
            num(rowData.newkhadya) +
            num(rowData.newratib) +
            (localStorage.getItem("karj") === "On" ? num(rowData.newkarj) : 0) +
            (localStorage.getItem("sanghk") === "On" ? num(rowData.newsangh) : 0) +
            (localStorage.getItem("retan") === "On" ? num(rowData.newretan) : 0)),
        0
      ),
    };
  } else if (khrtype === "udhari" && bill10type === "0" && customerData.length > 0) {
    totals = {
      tamtud: customerData.reduce((total, rowData) => total + num(rowData.tbaki), 0),
    };
  } else if (khrtype === "stock" && customerData.length > 0) {
    totals = {
      pur: customerData.reduce((total, rowData) => total + num(rowData.total_purchase_qty), 0),
      sale: customerData.reduce((total, rowData) => total + num(rowData.total_sale_qty), 0),
      stock: customerData.reduce((total, rowData) => total + num(rowData.stock), 0),
    };
  } else if (khrtype === "dreport" && customerData.length > 0) {
    totals = {
      quin: customerData.reduce((total, rowData) => total + num(rowData.quin), 0),
      tamt: Number(
        customerData.reduce((total, user) => {
          if (user.trantype === "Debit") return total + num(user.amt);
          return total - num(user.amt);
        }, 0) + num(PreviousAmt)
      ).toFixed(2),
    };
  }

  // ---------------- common header strings ----------------
  const periodLine = t("Khadyaadvreport.print.period", {
    from: formatDate(localStorage.getItem("date1print")),
    to: formatDate(localStorage.getItem("date2print")),
  });

  return (
    <PDFViewer className="pdf">
      <Document>
        {Array.isArray(customerData) && customerData.length > 0 ? (
          <>
            {/* KHADYA PURCHASE */}
            {khrtype === "khpur" && (
              <Page size="A4">
                <Text style={F(styles.latoText)}>{localStorage.getItem("kendra")}</Text>
                <Text style={F(styles.latoText2)}>{t("Khadyaadvreport.radios.khpur")}</Text>
                <Text style={F(styles.latoText2)}>{periodLine}</Text>

                <View style={styles.table}>
                  <View style={styles.tableRow}>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.khpur.date")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.khpur.khadyaName")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.khpur.qty")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.khpur.rate")}</Text>
                    <Text style={F(styles.tableHeaderlast)}>{t("Khadyaadvreport.tables.khpur.amount")}</Text>
                  </View>

                  {customerData.map((rowData, index) => (
                    <View key={index} style={styles.tableRow}>
                      <Text style={F(styles.tableCell)}>{rowData.date}</Text>
                      <Text style={F(styles.tableCell)}>{rowData.khname}</Text>
                      <Text style={F(styles.tableCell)}>{rowData.quin}</Text>
                      <Text style={F(styles.tableCell)}>{rowData.rate}</Text>
                      <Text style={F(styles.tableCell)}>{rowData.amt}</Text>
                    </View>
                  ))}

                  <View style={styles.tableRow3}>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.common.total")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.common.dash")}</Text>
                    <Text style={F(styles.tableHeader)}>{num(totals.tquin).toFixed(2)}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.common.dash")}</Text>
                    <Text style={F(styles.tableHeaderlast)}>{num(totals.tamt).toFixed(2)}</Text>
                  </View>
                </View>
              </Page>
            )}

            {/* KHADYA SALE */}
            {khrtype === "khsale" && (
              <Page size="A4">
                <Text style={F(styles.latoText)}>{localStorage.getItem("kendra")}</Text>
                <Text style={F(styles.latoText2)}>{t("Khadyaadvreport.radios.khsale")}</Text>
                <Text style={F(styles.latoText2)}>{periodLine}</Text>

                <View style={styles.table}>
                  <View style={styles.tableRow}>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.khsale.date")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.khsale.accountName")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.khsale.khadyaName")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.khsale.qty")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.khsale.rate")}</Text>
                    <Text style={F(styles.tableHeaderlast)}>{t("Khadyaadvreport.tables.khsale.amount")}</Text>
                  </View>

                  {customerData.map((rowData, index) => (
                    <View key={index} style={styles.tableRow}>
                      <Text style={F(styles.tableCell)}>{rowData.date}</Text>
                      <Text style={F(styles.tableCell)}>{rowData.cname}</Text>
                      <Text style={F(styles.tableCell)}>{rowData.khname}</Text>
                      <Text style={F(styles.tableCell)}>{rowData.quin}</Text>
                      <Text style={F(styles.tableCell)}>{rowData.rate}</Text>
                      <Text style={F(styles.tableCell)}>{rowData.amt}</Text>
                    </View>
                  ))}

                  <View style={styles.tableRow3}>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.common.total")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.common.dash")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.common.dash")}</Text>
                    <Text style={F(styles.tableHeader)}>{num(totals.tquin).toFixed(2)}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.common.dash")}</Text>
                    <Text style={F(styles.tableHeaderlast)}>{num(totals.tamt).toFixed(2)}</Text>
                  </View>
                </View>
              </Page>
            )}

            {/* STOCK */}
            {khrtype === "stock" && (
              <Page size="A4">
                <Text style={F(styles.latoText)}>{localStorage.getItem("kendra")}</Text>
                <Text style={F(styles.latoText2)}>{t("Khadyaadvreport.print.titles.stock")}</Text>

                <View style={styles.table}>
                  <View style={styles.tableRow}>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.stockSimple.srNo")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.stockSimple.khadyaName")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.print.table.company")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.stockSimple.totalPurchase")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.stockSimple.totalSale")}</Text>
                    <Text style={F(styles.tableHeaderlast)}>{t("Khadyaadvreport.tables.stockSimple.stock")}</Text>
                  </View>

                  {customerData.map((rowData, index) => (
                    <View key={index} style={styles.tableRow}>
                      <Text style={F(styles.tableCell)}>{index + 1}</Text>
                      <Text style={F(styles.tableCell)}>{rowData.khname}</Text>
                      <Text style={F(styles.tableCell)}>{rowData.khcompany}</Text>
                      <Text style={F(styles.tableCell)}>{rowData.total_purchase_qty}</Text>
                      <Text style={F(styles.tableCell)}>{rowData.total_sale_qty}</Text>
                      <Text style={F(styles.tableCell)}>{rowData.stock}</Text>
                    </View>
                  ))}

                  <View style={styles.tableRow3}>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.common.total")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.common.dash")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.common.dash")}</Text>
                    <Text style={F(styles.tableHeader)}>{num(totals.pur).toFixed(2)}</Text>
                    <Text style={F(styles.tableHeader)}>{num(totals.sale).toFixed(2)}</Text>
                    <Text style={F(styles.tableHeaderlast)}>{num(totals.stock).toFixed(2)}</Text>
                  </View>
                </View>
              </Page>
            )}

            {/* DATE STOCK */}
            {khrtype === "datestock" && (
              <Page size="A4">
                <Text style={F(styles.latoText)}>{localStorage.getItem("kendra")}</Text>
                <Text style={F(styles.latoText2)}>
                  {t("Khadyaadvreport.print.titles.datestock", { khname: localStorage.getItem("khname") })}
                </Text>

                <View style={styles.table}>
                  <View style={styles.tableRow}>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.dateStock.date")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.dateStock.openingStock")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.dateStock.purchase")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.dateStock.sale")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.dateStock.closingStock")}</Text>
                  </View>

                  {customerData.map((rowData, index) => (
                    <View key={index} style={styles.tableRow}>
                      <Text style={F(styles.tableCell)}>{rowData.date}</Text>
                      <Text style={F(styles.tableCell)}>{rowData.opening_stock}</Text>
                      <Text style={F(styles.tableCell)}>{rowData.purchase_qty}</Text>
                      <Text style={F(styles.tableCell)}>{rowData.sale_qty}</Text>
                      <Text style={F(styles.tableCell)}>{rowData.closing_stock}</Text>
                    </View>
                  ))}
                </View>
              </Page>
            )}

            {/* UDHARI (bill10type 1) - multi pages */}
            {khrtype === "udhari" && bill10type === "1" &&
              (() => {
                const showKarj = localStorage.getItem("karj") === "On";
                const showSangh = localStorage.getItem("sanghk") === "On";
                const showRetan = localStorage.getItem("retan") === "On";

                const Recordpages = chunk(customerData || [], 37);

                return Recordpages.map((pageRows, pageIndex, allPages) => (
                  <Page key={pageIndex} size="A4">
                    <Text style={F(styles.latoText)}>{localStorage.getItem("kendra")}</Text>
                    <Text style={F(styles.latoText2)}>{t("Khadyaadvreport.print.titles.udhari")}</Text>

                    <View style={styles.table}>
                      <View style={styles.tableRowhead}>
                        <Text style={F(styles.tableHeadersmall)}>{t("Khadyaadvreport.tables.udhariBill10type1.accountNo")}</Text>
                        <Text style={F(styles.tableHeaderlarge)}>{t("Khadyaadvreport.print.table.memberName")}</Text>
                        <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.udhariBill10type1.lastBill")}</Text>
                        <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.udhariBill10type1.advanceDue")}</Text>
                        <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.udhariBill10type1.khadyaDue")}</Text>
                        <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.udhariBill10type1.ratibDue")}</Text>
                        {showKarj ? <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.udhariBill10type1.loanDue")}</Text> : null}
                        {showSangh ? <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.udhariBill10type1.sanghDue")}</Text> : null}
                        {showRetan ? <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.udhariBill10type1.retanDue")}</Text> : null}
                        <Text style={F(styles.tableHeaderlast)}>{t("Khadyaadvreport.tables.udhariBill10type1.totalDue")}</Text>
                      </View>

                      {pageRows.map((rowData, i) => {
                        const adv = num(rowData.newadv);
                        const khad = num(rowData.newkhadya);
                        const ratib = num(rowData.newratib);
                        const karj = showKarj ? num(rowData.newkarj) : 0;
                        const sangh = showSangh ? num(rowData.newsangh) : 0;
                        const retan = showRetan ? num(rowData.newretan) : 0;
                        const rowTotal = adv + khad + ratib + karj + sangh + retan;

                        return (
                          <View key={`${pageIndex}-${i}`} style={styles.tableRow} wrap={false}>
                            <Text style={F(styles.tableCellsmall)}>{rowData.kno}</Text>
                            <Text style={F(styles.tableCelllarge)}>{rowData.cname}</Text>
                            <Text style={F(styles.tableCell)}>{rowData.date2}</Text>
                            <Text style={F(styles.tableCell)}>{adv.toFixed(2)}</Text>
                            <Text style={F(styles.tableCell)}>{khad.toFixed(2)}</Text>
                            <Text style={F(styles.tableCell)}>{ratib.toFixed(2)}</Text>
                            {showKarj ? <Text style={F(styles.tableCell)}>{karj.toFixed(2)}</Text> : null}
                            {showSangh ? <Text style={F(styles.tableCell)}>{sangh.toFixed(2)}</Text> : null}
                            {showRetan ? <Text style={F(styles.tableCell)}>{retan.toFixed(2)}</Text> : null}
                            <Text style={F(styles.tableCell)}>{rowTotal.toFixed(2)}</Text>
                          </View>
                        );
                      })}

                      {pageIndex === allPages.length - 1 && (
                        <View style={styles.tableRow3}>
                          <Text style={F(styles.tableHeadersmall)}>{t("Khadyaadvreport.common.total")}</Text>
                          <Text style={F(styles.tableHeaderlarge)}>{t("Khadyaadvreport.common.dash")}</Text>
                          <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.common.dash")}</Text>
                          <Text style={F(styles.tableHeader)}>{num(totals?.tamtadv).toFixed(2)}</Text>
                          <Text style={F(styles.tableHeader)}>{num(totals?.tamtkhadya).toFixed(2)}</Text>
                          <Text style={F(styles.tableHeader)}>{num(totals?.tamtratib).toFixed(2)}</Text>
                          {showKarj ? <Text style={F(styles.tableHeader)}>{num(totals?.tamtkarj).toFixed(2)}</Text> : null}
                          {showSangh ? <Text style={F(styles.tableHeader)}>{num(totals?.tamtsangh).toFixed(2)}</Text> : null}
                          {showRetan ? <Text style={F(styles.tableHeader)}>{num(totals?.tamtretan).toFixed(2)}</Text> : null}
                          <Text style={F(styles.tableHeaderlast)}>{num(totals?.tamt).toFixed(2)}</Text>
                        </View>
                      )}
                    </View>
                  </Page>
                ));
              })()
            }

            {/* UDHARI (bill10type 0) */}
            {khrtype === "udhari" && bill10type === "0" && (
              <Page size="A4">
                <Text style={F(styles.latoText)}>{localStorage.getItem("kendra")}</Text>
                <Text style={F(styles.latoText2)}>{t("Khadyaadvreport.print.titles.udhari")}</Text>

                <View style={styles.table}>
                  <View style={styles.tableRow}>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.udhariBill10type0.accountNo")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.print.table.memberName")}</Text>
                    <Text style={F(styles.tableHeaderlast)}>{t("Khadyaadvreport.tables.udhariBill10type0.udhariDue")}</Text>
                  </View>

                  {customerData.map((rowData, index) => (
                    <View key={index} style={styles.tableRow}>
                      <Text style={F(styles.tableCell)}>{rowData.kno}</Text>
                      <Text style={F(styles.tableCell)}>{rowData.cname}</Text>
                      <Text style={F(styles.tableCell)}>{num(rowData.tbaki).toFixed(2)}</Text>
                    </View>
                  ))}

                  <View style={styles.tableRow3}>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.common.total")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.common.dash")}</Text>
                    <Text style={F(styles.tableHeaderlast)}>{num(totals.tamtud).toFixed(2)}</Text>
                  </View>
                </View>
              </Page>
            )}

            {/* ADV REPORT */}
            {khrtype === "adv" && (
              <Page size="A4">
                <Text style={F(styles.latoText)}>{localStorage.getItem("kendra")}</Text>
                <Text style={F(styles.latoText2)}>{t("Khadyaadvreport.print.titles.adv")}</Text>
                <Text style={F(styles.latoText2)}>{periodLine}</Text>

                <View style={styles.table}>
                  <View style={styles.tableRow}>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.advanceReport.date")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.advanceReport.accountName")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.advanceReport.type")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.advanceReport.bankAccount")}</Text>
                    <Text style={F(styles.tableHeaderlast)}>{t("Khadyaadvreport.tables.advanceReport.amount")}</Text>
                  </View>

                  {customerData.map((rowData, index) => (
                    <View key={index} style={styles.tableRow}>
                      <Text style={F(styles.tableCell)}>{rowData.date}</Text>
                      <Text style={F(styles.tableCell)}>{rowData.cname}</Text>
                      <Text style={F(styles.tableCell)}>{rowData.type}</Text>
                      <Text style={F(styles.tableCell)}>{rowData.accno}</Text>
                      <Text style={F(styles.tableCell)}>{num(rowData.amt).toFixed(2)}</Text>
                    </View>
                  ))}

                  <View style={styles.tableRow3}>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.common.total")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.common.dash")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.common.dash")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.common.dash")}</Text>
                    <Text style={F(styles.tableHeaderlast)}>{num(totals.tamt).toFixed(2)}</Text>
                  </View>
                </View>
              </Page>
            )}

            {/* DEALER REPORT */}
            {khrtype === "dreport" && (
              <Page size="A4">
                <Text style={F(styles.latoText)}>{customerData?.[0]?.kendra || localStorage.getItem("kendra")}</Text>
                <Text style={F(styles.latoText)}>{t("Khadyaadvreport.print.titles.dreport")}</Text>
                <Text style={F(styles.latoText2)}>
                  {t("Khadyaadvreport.print.partyName", { name: localStorage.getItem("partyname") })}
                </Text>
                <Text style={F(styles.latoText2)}>{periodLine}</Text>

                <View style={styles.table}>
                  <View style={styles.tableRow}>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.dealerAccount.date")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.dealerAccount.particular")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.dealerAccount.debit")}</Text>
                    <Text style={F(styles.tableHeaderlast)}>{t("Khadyaadvreport.tables.dealerAccount.credit")}</Text>
                    <Text style={F(styles.tableHeaderlast)}>{t("Khadyaadvreport.tables.dealerAccount.balance")}</Text>
                  </View>

                  {customerData.map((rowData, index) => (
                    <View key={index} style={styles.tableRow}>
                      <Text style={F(styles.tableCell)}>{rowData.date}</Text>
                      <Text style={F(styles.tableCell)}>{rowData.particular}</Text>
                      <Text style={F(styles.tableCell)}>{num(rowData.nave).toFixed(2)}</Text>
                      <Text style={F(styles.tableCell)}>{num(rowData.jma).toFixed(2)}</Text>
                      <Text style={F(styles.tableCell)}>{num(rowData.closing_balance).toFixed(2)}</Text>
                    </View>
                  ))}

                  <View style={styles.tableRow3}>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.common.total")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.common.dash")}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.common.dash")}</Text>
                    <Text style={F(styles.tableHeaderlast)}>{num(totals.quin).toFixed(2)}</Text>
                    <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.common.dash")}</Text>
                    <Text style={F(styles.tableHeaderlast)}>{num(totals.tamt).toFixed(2)}</Text>
                  </View>
                </View>
              </Page>
            )}

            {/* THAKBAKI - multi pages */}
            {khrtype === "thakbaki" &&
              (() => {
                const showKarj = localStorage.getItem("karj") === "On";
                const showSangh = localStorage.getItem("sanghk") === "On";
                const showRetan = localStorage.getItem("retan") === "On";

                const Recordpages = chunk(customerData || [], 37);

                return Recordpages.map((pageRows, pageIndex, allPages) => (
                  <Page key={pageIndex} size="A4">
                    <Text style={F(styles.latoText)}>{localStorage.getItem("kendra")}</Text>
                    <Text style={F(styles.latoText2)}>{t("Khadyaadvreport.radios.thakbaki")}</Text>

                    <View style={styles.table}>
                      <View style={styles.tableRowhead}>
                        <Text style={F(styles.tableHeadersmall)}>{t("Khadyaadvreport.tables.thakbaki.accountNo")}</Text>
                        <Text style={F(styles.tableHeaderlarge)}>{t("Khadyaadvreport.print.table.memberName")}</Text>
                        <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.thakbaki.lastBill")}</Text>
                        <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.thakbaki.advanceDue")}</Text>
                        <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.thakbaki.khadyaDue")}</Text>
                        <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.thakbaki.ratibDue")}</Text>
                        {showKarj ? <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.thakbaki.loanDue")}</Text> : null}
                        {showSangh ? <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.thakbaki.sanghDue")}</Text> : null}
                        {showRetan ? <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.tables.thakbaki.retanDue")}</Text> : null}
                        <Text style={F(styles.tableHeaderlast)}>{t("Khadyaadvreport.tables.thakbaki.totalDue")}</Text>
                      </View>

                      {pageRows.map((rowData, i) => {
                        const adv = num(rowData.newadv);
                        const khad = num(rowData.newkhadya);
                        const ratib = num(rowData.newratib);
                        const karj = showKarj ? num(rowData.newkarj) : 0;
                        const sangh = showSangh ? num(rowData.newsangh) : 0;
                        const retan = showRetan ? num(rowData.newretan) : 0;
                        const rowTotal = adv + khad + ratib + karj + sangh + retan;

                        return (
                          <View key={`${pageIndex}-${i}`} style={styles.tableRow} wrap={false}>
                            <Text style={F(styles.tableCellsmall)}>{rowData.kno}</Text>
                            <Text style={F(styles.tableCelllarge)}>{rowData.cname}</Text>
                            <Text style={F(styles.tableCell)}>{rowData.date2}</Text>
                            <Text style={F(styles.tableCell)}>{adv.toFixed(2)}</Text>
                            <Text style={F(styles.tableCell)}>{khad.toFixed(2)}</Text>
                            <Text style={F(styles.tableCell)}>{ratib.toFixed(2)}</Text>
                            {showKarj ? <Text style={F(styles.tableCell)}>{karj.toFixed(2)}</Text> : null}
                            {showSangh ? <Text style={F(styles.tableCell)}>{sangh.toFixed(2)}</Text> : null}
                            {showRetan ? <Text style={F(styles.tableCell)}>{retan.toFixed(2)}</Text> : null}
                            <Text style={F(styles.tableCell)}>{rowTotal.toFixed(2)}</Text>
                          </View>
                        );
                      })}

                      {pageIndex === allPages.length - 1 && (
                        <View style={styles.tableRow3}>
                          <Text style={F(styles.tableHeadersmall)}>{t("Khadyaadvreport.common.total")}</Text>
                          <Text style={F(styles.tableHeaderlarge)}>{t("Khadyaadvreport.common.dash")}</Text>
                          <Text style={F(styles.tableHeader)}>{t("Khadyaadvreport.common.dash")}</Text>
                          <Text style={F(styles.tableHeader)}>{num(totals?.tamtadv).toFixed(2)}</Text>
                          <Text style={F(styles.tableHeader)}>{num(totals?.tamtkhadya).toFixed(2)}</Text>
                          <Text style={F(styles.tableHeader)}>{num(totals?.tamtratib).toFixed(2)}</Text>
                          {showKarj ? <Text style={F(styles.tableHeader)}>{num(totals?.tamtkarj).toFixed(2)}</Text> : null}
                          {showSangh ? <Text style={F(styles.tableHeader)}>{num(totals?.tamtsangh).toFixed(2)}</Text> : null}
                          {showRetan ? <Text style={F(styles.tableHeader)}>{num(totals?.tamtretan).toFixed(2)}</Text> : null}
                          <Text style={F(styles.tableHeaderlast)}>{num(totals?.tamt).toFixed(2)}</Text>
                        </View>
                      )}
                    </View>
                  </Page>
                ));
              })()
            }
          </>
        ) : (
          ""
        )}
      </Document>
    </PDFViewer>
  );
};

export default Khadyaadvreportprint;


// ... (styles and export)



const styles = StyleSheet.create({
    page: {
        paddingTop: 10,
        flexDirection: 'row',
        justifyContent: 'center', // Center horizontally
    },
    header: {
        position: 'absolute',
        top: 0, // Adjust this value to change the vertical position
        left: 0,
        right: 0,
        textAlign: 'center',
    },
    tableContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100vw',
        justifyContent: 'space-between',
    },
    table: {
        display: 'table',
        width: '97%', // Adjust as needed to fit four tables in a row
        margin: 5,
    },
    tableone: {
        display: 'table',
        width: '18%', // Adjust as needed to fit four tables in a row
        margin: 5,
    },
    tableCellone: {
        border: '0.5px solid black',
        padding: 0.5,
        fontSize: 8,
        fontFamily: 'Lato-Italic',
        textAlign: 'center',
        flex: 1, // Remove width and use flex to distribute space equally
    },
    tableRowone: {
        flexDirection: 'row',
        width: '100%',
    },
    tableHeaderone: {
        fontFamily: 'Lato-Italic',
        fontWeight: 'bold',
        border: '1px solid #000',
        padding: 2,
        fontSize: 8,
        textAlign: 'center',
        flex: 1, // Remove width and use flex to distribute space equally
    },

    tableRow: {
        flexDirection: 'row',

    },
    tableRowhead: {
        flexDirection: 'row',
        backgroundColor: 'lightgray',
    },
    tableRow2: {
        flexDirection: 'row',
        backgroundColor: 'lightgray',
        marginTop: 5,
    },

    tableRow3: {
        flexDirection: 'row',
        backgroundColor: 'lightgray',
        marginTop: 10,
    },
    line: {
        flexDirection: 'row',
        backgroundColor: 'lightgray',
        marginTop: 5,
        height: 1,
        width: '100vw',
        marginBottom: 5,
    },
    tableHeader: {
        fontFamily: 'Lato-Italic',
        fontWeight: 'bold',
        borderTopWidth: 1,    // Add border only for top side
        borderBottomWidth: 1, // Add border only for bottom side
        borderLeftWidth: 1,   // Add border only for left side
        borderRightWidth: 0,  // No border for right side
        borderStyle: 'solid', // Set the border style to 'solid'
        padding: 2,
        flex: 0.5,
        borderColor: 'black',
        textAlign: 'center',
        fontSize: 9,
    },
    tableHeaderlarge: {
        fontFamily: 'Lato-Italic',
        fontWeight: 'bold',
        borderTopWidth: 1,    // Add border only for top side
        borderBottomWidth: 1, // Add border only for bottom side
        borderLeftWidth: 1,   // Add border only for left side
        borderRightWidth: 0,  // No border for right side
        borderStyle: 'solid', // Set the border style to 'solid'
        padding: 2.0,
        flex: 0.9,
        borderColor: 'black',
        paddingLeft: 10,
        textAlign: 'left',
        fontSize: 9,
    },
    tableHeadersmall: {
        fontFamily: 'Lato-Italic',
        fontWeight: 'bold',
        borderTopWidth: 1,    // Add border only for top side
        borderBottomWidth: 1, // Add border only for bottom side
        borderLeftWidth: 1,   // Add border only for left side
        borderRightWidth: 0,  // No border for right side
        borderStyle: 'solid', // Set the border style to 'solid'
        padding: 2,
        flex: 0.2,
        borderColor: 'black',
        textAlign: 'center',
        fontSize: 9,
    },
    tableHeaderlast: {
        fontFamily: 'Lato-Italic',
        fontWeight: 'bold',
        borderTopWidth: 1,    // Add border only for top side
        borderBottomWidth: 1, // Add border only for bottom side
        borderLeftWidth: 1,   // Add border only for left side
        borderRightWidth: 1,  // No border for right side
        borderStyle: 'solid', // Set the border style to 'solid'
        borderColor: 'black',
        padding: 2,
        flex: 0.5,
        textAlign: 'center',
        fontSize: 9,
    },
    tableCell: {
        border: '0.5px solid black',
        padding: 0.5,
        flex: 1,
        fontSize: 10,
        fontFamily: 'Lato-Italic',
        width: 2,
        textAlign: 'center',
    },
    tableCelllarge: {
        border: '0.5px solid black',
        padding: 0.5,
        flex: 1.77,
        fontSize: 10,
        fontFamily: 'Lato-Italic',
        width: 2,
        textAlign: 'left',
        paddingLeft: 10,
    },
    tableCellsmall: {
        border: '0.5px solid black',
        padding: 0.5,
        flex: 0.42,
        fontSize: 10,
        fontFamily: 'Lato-Italic',
        width: 1.2,
        textAlign: 'center',
    },
    tableCellgreen: {
        border: '0.5px solid black',
        padding: 0.5,
        flex: 1,
        fontSize: 10,
        fontWeight: 'bold',
        fontFamily: 'Lato-Italic',
        color: 'green',
        width: 2,
        textAlign: 'center',
    },
    tableCellred: {
        border: '0.5px solid black',
        padding: 0.5,
        flex: 1,
        fontSize: 9,
        fontWeight: 'bold',
        fontFamily: 'Lato-Italic',
        color: 'red',
        width: 2,
        textAlign: 'center',
    },
    latoTextlarge: {
        fontFamily: 'Lato-Italic',
        fontSize: 15,
        marginBottom: 5,
        textAlign: 'center',
        width: '100vw',
        fontWeight: 'bold',
        marginTop: 5,
    },
    latoText: {
        fontFamily: 'Lato-Italic',
        fontSize: 14,
        marginBottom: -2,
        textAlign: 'center',
        width: '100vw',
        fontWeight: 'bold',
        marginTop: 2,
    },
    latoText2: {
        fontFamily: 'Lato-Italic',
        fontSize: 11,
        textAlign: 'center',
        width: '100vw',
        fontWeight: 'bold',
    },
    headtextsmall: {
        fontFamily: 'Lato-Italic',
        fontSize: 10,
        fontWeight: 'bold',
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        width: '100vw',
    },
    row1: {
        display: 'flex',
        flexDirection: 'row',
        width: '100vw',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingLeft: 5,
        paddingRight: 5,
    },
    row2: {
        display: 'flex',
        flexDirection: 'row',
        width: '100vw',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingLeft: 140,
        paddingRight: 140,
        backgroundColor: 'lightgray',
    },
    column1: {
        display: 'flex',
        flexDirection: 'column',
        width: '19%',
        justifyContent: 'start',
        alignItems: 'flex-start', // Align text to the left
        paddingLeft: 5,
        paddingRight: 5,
        marginLeft: 20,
    },
    column2: {
        display: 'flex',
        flexDirection: 'column',
        width: '15%',
        justifyContent: 'start',
        alignItems: 'flex-start', // Align text to the left
        paddingLeft: 5,
        paddingRight: 5,


    },
    column3: {
        display: 'flex',
        flexDirection: 'column',
        width: '17%',
        justifyContent: 'start',
        alignItems: 'flex-start', // Align text to the left
        paddingLeft: 5,
        paddingRight: 5,
        marginLeft: 20,
    },
    column1Row: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
    },
    column1Rowgray: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        padding: 6,
        marginTop: 5,
        border: '0.5px solid black',
        backgroundColor: 'lightgray'
    },
    column1Label: {
        fontFamily: 'Lato-Italic',
        fontSize: 9,
        fontWeight: 'bold',
        textAlign: 'left', // Align labels to the left
    },
    column1Value: {
        fontFamily: 'Lato-Italic',
        fontSize: 9,
        fontWeight: 'bold',
        textAlign: 'right', // Align values to the right
    },
    pageBreak: {
        pageBreakBefore: 'always',
    },
    totalsRow: {
        flexDirection: 'row',
        borderTop: '1px solid #000',
        paddingTop: 5,
        paddingLeft: 2,
    },
    totalsCell: {
        border: '0.5px solid black',
        padding: 0.5,
        flex: 1,
        fontSize: 8,
        width: 2,
        textAlign: 'center',
    },
    imagerow: {
        display: 'flex',
        flexDirection: 'row',
        width: '100vw',
        justifyContent: 'center',
        alignItems: 'center',
    },
    image: {
        width: 80, // Adjust the width as needed
        height: "auto", // Maintain aspect ratio
        marginLeft: -15,
        marginTop: 5

    },
    imgtext: {
        fontFamily: 'Lato-Italic',
        fontSize: 9,
        fontWeight: 'bold',
        textAlign: 'center', // Align labels to the left
    },
});
